import { Component, OnInit, Inject } from '@angular/core';
import { EsriUserService, EsriUser } from '../../../../common-services/esri-user.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SubsUser } from '../../../../common-services/user-management.service';

export interface ModalUserEsriInput {
	existingUsers: SubsUser[]
}

@Component({
	selector: 'app-modal-users-esri',
	templateUrl: './modal-users-esri.component.html',
	styleUrls: ['./modal-users-esri.component.css']
})
export class ModalUsersEsriComponent implements OnInit {

	public users: EsriUser[] = [];
	public selectedUser;
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: ModalUserEsriInput,
		public dialogRef: MatDialogRef<ModalUsersEsriComponent>,
		private esriUserService: EsriUserService
	) { }

	async ngOnInit() {
		console.log(this.esriUserService.esriUserInfo);
		const existingUsers = this.data.existingUsers || [];
		const users = await this.esriUserService.getEsriUsers() || [];
		this.users = users.filter(u => {
			return !existingUsers.find(e => e.userEmail.toLowerCase() === u.email.toLowerCase());
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/components/portal/user-manage/modal-users-esri/modal-users-esri.component.ts